/* Publish by EComposer at 2026-09-28 18:25:14*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2nvgo2p0g73"]=  window.__ectimmers["ecom-2nvgo2p0g73"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2nvgo2p0g73').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2nvgo2p0g73', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jh7p0x8q8ml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jh7p0x8q8ml', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0khdsaj15bir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0khdsaj15bir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hl0kxdjd9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hl0kxdjd9g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t8fwnmfb247').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t8fwnmfb247', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1y63utvxb89h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1y63utvxb89h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4ckz893ow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4ckz893ow', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5egaptvppq9"]=  window.__ectimmers["ecom-5egaptvppq9"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-5egaptvppq9"]["z9p76504z"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-5egaptvppq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5egaptvppq9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b38ctsuub1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b38ctsuub1i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y918lxqqtcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y918lxqqtcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m0zb1fidun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m0zb1fidun', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1mc66uerd6b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1mc66uerd6b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-scoqljh8jv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-scoqljh8jv', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ibzwo9xbh8p"]=  window.__ectimmers["ecom-ibzwo9xbh8p"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-ibzwo9xbh8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ibzwo9xbh8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-syokdqhrjbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-syokdqhrjbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4vqmlbkjwam').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4vqmlbkjwam', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-v82q84f35wc"]=  window.__ectimmers["ecom-v82q84f35wc"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-v82q84f35wc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v82q84f35wc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-38bfqmgxm22').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-38bfqmgxm22', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u5f8raas3me').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u5f8raas3me', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qjetjj3jl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qjetjj3jl9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qba1hdeqeqg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qba1hdeqeqg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsvsuzew2v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsvsuzew2v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-efkm7555iif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-efkm7555iif', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}